import { MsalAuthProvider } from 'react-aad-msal';

import { authConfig, authParams, authOptions } from 'config/auth-config';

import type { Configuration } from 'msal';

export const msalAuthProvider = new MsalAuthProvider(
  authConfig as Configuration,
  authParams,
  authOptions
);
